import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconProviderCustom } from 'assets/icons/provider-custom.svg'
import { ReactComponent as IconSearchCustom } from 'assets/icons/search-custom.svg'
import useTranslation from 'hooks/useTranslations'
import useStyles from './styles'

const Heading = props => {
  const { type, as, title, number } = props
  const classes = useStyles()
  const t = useTranslation()

  return (
    <Box className={classes.root}>
      <Typography variant={as || 'h2'}>{title}</Typography>
      {!isNaN(number) ? (
        <Box display="flex">
          <Box className={classes.icon}>
            <SvgIcon
              component={
                type === 'vendors'
                  ? IconProviderCustom
                  : type === 'searches'
                  ? IconSearchCustom
                  : null
              }
            />
          </Box>
          <Typography variant="body1" className={classes.text}>
            {number}{' '}
            <Hidden xsDown>
              {type === 'vendors' ? (
                <>{t(number === 1 ? 'vendor' : 'vendors')}</>
              ) : type === 'searches' ? (
                <>
                  {t(
                    number === 1 ? 'home:saved-search' : 'home:saved-searches',
                  )}
                </>
              ) : null}
            </Hidden>
          </Typography>
        </Box>
      ) : null}
    </Box>
  )
}

Heading.propTypes = {
  type: PropTypes.oneOf(['vendors', 'searches']).isRequired,
  as: PropTypes.oneOf(['h1', 'h2']),
  title: PropTypes.string.isRequired,
  number: PropTypes.number,
}

export default Heading
